
import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';


@Component({
  selector: 'app-modal-acciones-autoridad',
  templateUrl: './modal-acciones-autoridad.component.html',
  styleUrls: ['./modal-acciones-autoridad.component.scss']
})
export class ModalAccionesAutoridadComponent implements OnInit {
  usuario=null;
  procesodeEliminarActivo=false
  procesodeEditarActivo=false
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''
  trabajando=false

  autoridadAislante=false
  autoridadArea=false
  autoridadAreaLocal=false
  autoridadHSE=false
  gerenteRegional=false
  botondisabled=true

  constructor(public activeModal: NgbActiveModal, private functions: AngularFireFunctions) { }

  ngOnInit(): void {
    this.autoridadAislante=this.usuario.data().autoridadAislante;
    this.autoridadArea=this.usuario.data().autoridadArea;
    this.autoridadAreaLocal=this.usuario.data().autoridadAreaLocal;
    this.autoridadHSE=this.usuario.data().autoridadHSE;
    this.gerenteRegional=this.usuario.data().gerenteRegional;
  }



  cerrar(parametro){
    this.activeModal.close(parametro);//esto no lo estamos usando pero es para tenerlo ahi 
  }

  confirmaEliminar(){
    this.procesodeEliminarActivo=true
  }
  cancelarEliminar(){
    this.procesodeEliminarActivo=false
  }

  confirmaUpdate(){
    this.procesodeEditarActivo=true
  }
  cancelaUpdate(){
    this.procesodeEditarActivo=false
  }

  eliminarCuenta(idParaEliminar){

    this.trabajando=true
    this.alerta("warning","eliminando autoridad...")

    // Use the function name from Firebase
    const callable = this.functions.httpsCallable('deleteUser');
  
    // Create an Observable and pass any data you want to the function
    const obs = callable({id: idParaEliminar});
  
    obs.subscribe( res => {
  
        if(res.result =="OK"){
  
          //despues de eliminada la cuenta, se elimina de la coleccion de users y despues de la de autoridades
          firebase.firestore().collection("users").doc(idParaEliminar).delete().then(()=>{
            firebase.firestore().collection("autoridades").doc(idParaEliminar).delete().then(()=>{
              this.procesodeEliminarActivo=false
              this.alerta("success","¡Autoridad eliminada con éxito!")
              this.cerrar("OK")
            })
            
          }).catch((err)=>{
            this.alerta("danger",err)
            this.cerrar(err)
          })
        }else
        if(res.result !="OK"){
          this.cerrar(res.result)
          this.alerta("danger",res.result)
          console.log("RESPUESTA DE LA FUNCION: "+res.result)
          this.procesodeEliminarActivo=false
        }
    });
  }

  update(id){
    firebase.firestore().collection("autoridades").doc(id).update({

      autoridadAislante:this.autoridadAislante,
      autoridadArea:this.autoridadArea,
      autoridadAreaLocal:this.autoridadAreaLocal,
      autoridadHSE:this.autoridadHSE,
      gerenteRegional:this.gerenteRegional,

    }).then(()=>{
      this.procesodeEditarActivo=false
      this.alerta("success","¡Autoridad editada con éxito!")
      this.cerrar("OK")
    }).catch((err)=>{
      this.procesodeEditarActivo=false
      this.alerta("danger",err)
      this.cerrar("OK")
    })
  }


  
  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }
  
  
  
  closeAlert(){
    this.alertaActiva=false
  }

  validaboton(){
    console.log("validaboton activado")
      if( (this.autoridadAislante ==true || this.autoridadArea ==true || this. autoridadAreaLocal ==true|| this.autoridadHSE ==true || this.gerenteRegional ==true ) ){this.botondisabled=false}
      
      if (this.autoridadAislante ==false && this.autoridadArea ==false && this. autoridadAreaLocal ==false&& this.autoridadHSE ==false && this.gerenteRegional ==false){this.botondisabled=true}
  }


}//fin de clase

